// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import VueFire from 'vuefire'

import * as firebase from 'firebase'

import router from './router'
import { store } from './store'

import App from './App'
import MainMenu from '@/components/MainMenu'

import Spinner from 'vue-simple-spinner'

Vue.use(VueFire)

Vue.component('main-menu', MainMenu)
Vue.component('spinner', Spinner)

Vue.config.productionTip = false

require('./foundation.min.css')
require('./style.css')

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    created () {
        firebase.initializeApp({
            apiKey: "AIzaSyDwzTXaBJxNudaPHLgfseR2sybXoTWVth0",
            authDomain: "mysneakercollection.firebaseapp.com",
            databaseURL: "https://mysneakercollection.firebaseio.com",
            projectId: "mysneakercollection",
            storageBucket: "",
            messagingSenderId: "514837027216"
        })
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.$store.dispatch('autoSignIn', user)
                this.$store.dispatch('fetchUserData')
            }
        })
        this.$store.dispatch('loadSneakers')
        this.$store.dispatch('loadBrands')
    }
})



// WEBPACK FOOTER //
// ./src/main.js